import { render, staticRenderFns } from "./modification.vue?vue&type=template&id=13231556"
import script from "./modification.vue?vue&type=script&lang=ts"
export * from "./modification.vue?vue&type=script&lang=ts"
import style0 from "./modification.vue?vue&type=style&index=0&id=13231556&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports